export default __webpack_public_path__ + "static/media/330_business05-nl-mobile.7853938d.png";